/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React from 'react';
import { FormattedMessage } from 'react-intl';
import InfoIcon from '@mui/icons-material/esm/Info';
import ErrorIcon from '@mui/icons-material/esm/ReportProblem';
import * as Colors from '@mui/material/colors';
import * as Actions from '../constants/ActionTypes';
import NotificationCenter from '../helper/NotificationCenter';

const defaultNotificationsState = {
	counter: 0,
	notifications: [],
	labels: [],
};

function addNotification(notification, state) {
	let hasAlready = false;
	const notifications = state.notifications.map(n => {
		if(n.message === notification.message && n.title === notification.title) {
			n.timestamp = Date.now();
			hasAlready = true;
		}
		return n;
	});
	if(!hasAlready) {
		notification.labels = notification.labels || [];
		notification.labels.forEach((label) => {
			if (label && !state.labels.includes(label)) state.labels.push(label);
		});
		state.notifications.unshift(notification);
	} else {
		state.notifications = notifications.slice();
	}
}
function increaseNotificationCounter(state) {
	return {
		...state,
		counter: state.counter + 1,
		notifications: state.notifications
	};
}

export default function notificationsReducer(state = defaultNotificationsState, action) {
	let notification = null;
	switch (action.type) {
		case Actions.SEND_RESTORE_ERROR:
			notification = {
				title: <FormattedMessage id="Request.failed" defaultMessage="Request failed" />,
				message: (
					<FormattedMessage
						id="Database.RestoreErrorMessage"
						defaultMessage="Restore Failed"
					/>
				),
				color: Colors.red[600],
				icon: <ErrorIcon />,
				timestamp: Date.now(),
				error: <FormattedMessage id="Request.failed" defaultMessage="Request failed" />,
			};
			NotificationCenter.showNotification(notification);
			addNotification(notification, state);
			return increaseNotificationCounter(state);
		case Actions.SEND_RESTORE_SUCCESS:
			notification = {
				title: (
					<FormattedMessage
						id="Database.RestoreSuccessTitle"
						defaultMessage="Restore Successful"
					/>
				),
				message: (
					<FormattedMessage
						id="Database.RestoreSuccessMessage"
						defaultMessage="Restore Successful"
					/>
				),
				color: Colors.green[600],
				icon: <InfoIcon />,
				timestamp: Date.now(),
			};
			NotificationCenter.showNotification(notification);
			addNotification(notification, state);
			return increaseNotificationCounter(state);
		case Actions.NOTIFICATIONS_CLEAR:
			return {
				...state,
				notifications: [],
				labels: [],
			};
		default:
			return state;
	}
}
